import List, { type ListProps } from '@liquidweb-dev/undercurrent/List';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const ListWrapper = ({ sx, ...rest }: ListProps) => (
	<List
		sx={combineSx(
			{
				flexGrow: 1,
				maxHeight: 'none',
				borderColor: ({ vars }) => vars.palette.uc.border.weak,
			},
			sx,
		)}
		{...rest}
	/>
);

export default ListWrapper;
